import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-lighter to-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <button
            onClick={() => navigate('/')}
            className="text-gray-400 hover:text-white transition-colors flex items-center space-x-2"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back to Home</span>
          </button>
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/ITLss-white.svg?alt=media&token=062a9f72-4dcd-4185-b0be-9f5aecf9943c" 
            alt="InsighTalks" 
            className="h-10 object-contain"
          />
        </div>

        <div className="w-full h-[calc(100vh-160px)]">
          <iframe
            className="typeform-widget w-full h-full"
            src="https://insightalks.typeform.com/to/il0DWT82"
            frameBorder="0"
            title="Contact Form"
            allow="camera; microphone; autoplay; encrypted-media; fullscreen"
          />
        </div>
      </div>
    </div>
  );
}